import React, { Component } from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import SpotlioIcon from '../Icon';

import { getSystemSettings } from "../../utils/SettingsRetriever";
 
import './QuantitySelector.scss';

class QuantitySelector extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.default ? this.props.default : 0,
            max: this.props.max ? this.props.max : 50,
            min: this.props.min !== undefined ? this.props.min : 1,
            hasChanged: this.props.make ? true : false
        }
    }

    shouldComponentUpdate(nextProps){
        if (nextProps.max !== this.state.max || nextProps.min !== this.props.min) return true;
        if (!this.props.value){
            if (!this.state.hasChanged){
                return false
            } else {
                return true;
            }
        } else {
            return true;
        }

    }

    componentWillReceiveProps(nextProps){
        if (this.state.value !== nextProps.default || this.state.max !== nextProps.max || this.state.min !== nextProps.min){
            this.setState({value: nextProps.default, min: nextProps.min || 1, max: nextProps.max || 50})
        }
    }

    renderDropdownItems = () => {
        console.log(getSystemSettings().app.dropDownQuantities)
        let {min, max} = this.state;
        if(max > 50) max = 50;
        max += 1;

        let arrayOfItems = Array.from(new Array(max - min), (val, index) =>
            <MenuItem key={index + min} value={index + min}>{this.getLabelValue( (index + min).toString() )}</MenuItem>
        )

        if (getSystemSettings().app && getSystemSettings().app.dropDownQuantities && getSystemSettings().app.dropDownQuantities.length > 0){
            getSystemSettings().app.dropDownQuantities.forEach(val => {
                arrayOfItems.push(
                    <MenuItem key={val} value={val}>{this.getLabelValue( (val).toString() )}</MenuItem>
                )
            })
        }

        return arrayOfItems;
    }

    handleChange = (event) => {
        this.setState({
            value: event.target.value,
            hasChanged: true,
        }, () => this.props.whenChange(this.props.name, this.state.value))
    }

    getLabelValue = (value) => {
        let label = '';
        const icon = <SpotlioIcon size={12} icon={'feather-chevron-down'} />;

        if(this.props.showSymbol !== undefined){
            label = this.props.showSymbol + " ";
        }else{
            if(this.props.showName){
                label = value + " " + this.props.name;
                if(!this.state.hasChanged){
                    label = "Select " + this.props.name;
                }

                label += " " + icon;
            }
        }

        label += value;

        return label;
    }

    render() {
        return (
            <div className="quantitySelectorWrapper">
                <Select
                    variant={'outlined'}
                    name={this.props.name}
                    value={this.props.value !== undefined ? this.props.value : this.state.value}
                    onChange={this.handleChange}
                    className={"quantitySelector " + (!this.props.className ? 'default' : this.props.className)}
                    inputProps={{
                        name: 'ammount'
                    }}
                    renderValue={(value)=>
                        <React.Fragment>
                            { this.getLabelValue(value) }
                        </React.Fragment>
                    }
                >
                    { this.renderDropdownItems() }
                </Select>
            </div>
        );
    }
}

export default QuantitySelector;
